import { CustomThemeOptions } from '../types';
import { ColorMode } from '../ThemeModeContext';

import logoDark from '../../assets/tenants/paletrans/logoDark.svg';
import logoLight from '../../assets/tenants/paletrans/logoLight.svg';
import logoMain from '../../assets/tenants/paletrans/logo.svg';
import authCircleInside from '../../assets/tenants/paletrans/InnerCircle.png';
import authCircleOutside from '../../assets/tenants/paletrans/ellipse-outside.svg';

export const getPaletransThemeOptions = (mode: ColorMode = 'light'): CustomThemeOptions => {
  const isDark = mode === 'dark';

  return {
    palette: {
      mode,
      primary: isDark
        ? {
            main: '#4d77cf',
            light: '#7099e8',
            dark: '#2b4e8c',
            contrastText: '#ffffff',
          }
        : {
            main: '#2b4e8c', // Deep Blue
            light: '#4d6bad',
            dark: '#1c335e',
            contrastText: '#ffffff',
          },
      secondary: {
        main: isDark ? '#1c2538' : '#1a1a1a',
      },
      background: isDark
        ? {
            default: '#0a0f16',
            paper: '#172233', // Lighter, elevated card/blob surface
          }
        : {
            default: '#f8fafc',
            paper: '#ffffff',
          },
      text: isDark
        ? {
            primary: '#f1f5f9',
            secondary: '#94a3b8',
          }
        : {
            primary: '#1e293b',
            secondary: '#64748b',
          },
      divider: isDark ? 'rgba(255, 255, 255, 0.09)' : 'rgba(0, 0, 0, 0.08)',
      black: {
        main: '#2B2D2E',
        light: '#515151',
        dark: '#202122',
      },
      white: {
        main: '#EFEFEF',
        light: '#F5F5F5',
        dark: '#E8E8E8',
      },
    },
    typography: {
      button: {
        textTransform: 'none',
      },
      fontFamily: ['Mukta', 'Saira'].join(','),
    },
    breakpoints: {
      values: {
        xs: 0,
        sm: 961,
        md: 1200,
        lg: 1200,
        xl: 1536,
      },
    },
    gradients: {
      primary: isDark
        ? 'linear-gradient(90deg, #2b4e8c 0%, #4d77cf 100%)'
        : 'linear-gradient(90deg, #2b4e8c 0%, #1a1a1a 100%)',
      secondary: isDark
        ? 'linear-gradient(180deg, #1c335e 0%, #172233 100%)'
        : 'linear-gradient(180deg, #2b4e8c 0%, #1a1a1a 100%)',
    },
    media: {
      logos: {
        main: isDark ? logoLight : logoMain,
        light: logoLight,
        dark: logoDark,
      },
      authCircleInside,
      authCircleOutside,
    },
    components: {
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundImage: 'none',
            ...(isDark && {
              border: '1px solid rgba(255, 255, 255, 0.08)',
              boxShadow: '0 4px 20px -2px rgba(0, 0, 0, 0.45)',
            }),
          },
        },
      },
      MuiAppBar: {
        styleOverrides: {
          root: {
            backgroundColor: isDark ? '#172233' : '#ffffff',
            color: isDark ? '#f1f5f9' : '#1e293b',
          },
        },
      },
      MuiDrawer: {
        styleOverrides: {
          paper: {
            backgroundColor: isDark ? '#0f1724' : '#ffffff',
            borderRight: `1px solid ${isDark ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.08)'}`,
          },
        },
      },
    },
  };
};

export const paletransThemeOptions = getPaletransThemeOptions('light');
